import RxCartIcon from "./RxCartIcon";

export default RxCartIcon;
